export default {

  init() {
    $('[data-tab]').on('click', function(e) {
    	Tabs.switchTab(this);
    });
  },

  switchTab(elem) {
  	let $tab = $(elem);
  	let $target = $('#'+$tab.attr('aria-controls'));

  	if(!$target.length) {
  		return;
  	}

  	let $tablist = $tab.parents('[role=tablist]').first().find('[aria-controls]');
  	let $tabpanels = $target.parents('[role=tabpanels]').first().find('[aria-labelledby]');

  	$tablist.removeClass('is-active').attr('aria-selected', 'false');
  	$tab.addClass('is-active').attr('aria-selected', 'true');

  	$tabpanels.removeClass('is-active');
  	$target.addClass('is-active');
  }

};
